/**
 * @implements ISM - As it implements ISM interface, it must implement all interface methods.
 * Initializing controller property with ISMController to make data of all services accessible in base class and its children.
 */
export class ISMBase {
    constructor(controller) {
        this.controller = controller;
    }
    /**
     * Basic definition of a service provider promise. It is overridden in child class if there is an additional check required to do which is specific to the provider.
     * On page load, return data from LS if present. Else wait for the allocated time period. If data is available within this time period, return it else
     * return the appropriate message.
     * @return IdentityServiceProvider|string
     */
    fetchIdentityServiceProviderPromise() {
        return new Promise((resolve) => {
            try {
                let ISMLSData = this.controller.getISMDataFromLocalStorage(this.identityServiceProvider);
                if (ISMLSData.length) {
                    this.setIdentityServiceProviderTargeting(ISMLSData[0]);
                    resolve({ 'identityServiceProvider': this.identityServiceProvider, 'responseText': `${this.identityServiceProvider} Data was sent to GAM from LS on Page load`, value: ISMLSData[0] });
                }
                else {
                    setTimeout(() => {
                        let data = this.controller.getServiceData(this.identityServiceProvider);
                        if (data) {
                            this.controller.resolvedServicesData.push(data); // store it under this var so that we know which service providers resolved withing the given timeframe
                            this.setIdentityServiceProviderTargeting(data);
                            resolve({ 'identityServiceProvider': this.identityServiceProvider, 'responseText': `${this.identityServiceProvider} Data was fetched within the given timeframe`, value: data });
                        }
                        else {
                            resolve(this.getNoDataFoundMessage());
                        }
                    }, this.controller.timeout);
                }
            }
            catch (error) {
                resolve(this.getErrorMessage(error));
            }
        });
    }
    /**
     * Overridden in child classes to set targeting respective to the provider being executed.
     * @return void
     */
    setIdentityServiceProviderTargeting(identityServiceProviderData) { }
    /**
     * Message to display when a provider data is not found within the given timeframe.
     * @return string
     */
    getNoDataFoundMessage() {
        return { 'identityServiceProvider': this.identityServiceProvider, 'responseText': `${this.identityServiceProvider} data was not fetched within the given timeframe : ${this.identityServiceProvider} targeting skipped` };
    }
    /**
     * In case promise fails due to some error, display below message
     * @param error
     */
    getErrorMessage(error) {
        return { 'identityServiceProvider': this.identityServiceProvider, 'responseText': `${this.identityServiceProvider} targeting skipped : ${error}` };
    }
    /**
     *  To see if new data returned from a provider is different from the one stored in LocalStorage.
     */
    hasTargetingChanged() { }
    /**
     * Basic info to send to new relic
     */
    getDefaultNewRelicInfo() {
        let data = {};
        data['providerName'] = this.identityServiceProvider;
        data['pageUrl'] = location.href;
        data['browser'] = window.hmUtils && window.hmUtils.getBrowserName();
        data['sessionID'] = window.hmUtils && window.hmUtils.getOracleCookieId();
        return data;
    }
}
